import { gql } from '@apollo/client';

/**
 * Ops incidents — the tickets the log monitor raises from production errors,
 * and any raised by hand.
 *
 * A ticket groups every occurrence of one error signature (`fingerprint`): how
 * often it happened, whom it touched, what the classifier thinks caused it, and
 * where the fix stands.
 */

/* What the list shows of each ticket. */
export const OPS_INCIDENT_SUMMARY_FIELDS = `
  id
  title
  severity
  priority
  priorityScore
  category
  status
  service
  occurrences
  usersImpactedCount
  usersImpacted
  likelyCause
  suggestedFix
  assignedTo
  firstSeenAt
  lastSeenAt
  reopenedCount
  classifiedBy
  fixHolding
`;

/* Everything about one ticket, for its detail view. */
export const OPS_INCIDENT_DETAIL_FIELDS = `
  id
  fingerprint
  title
  severity
  priority
  priorityScore
  category
  status
  service
  services
  loggerName
  level
  exceptionType
  messageTemplate
  sampleMessage
  tracebackTail
  firstSeenAt
  lastSeenAt
  occurrences
  lastWindowOccurrences
  ratePerMin
  consecutiveWindows
  escalationLevel
  escalationReason
  usersImpactedCount
  usersImpacted
  sessionsImpactedCount
  instances
  classifiedBy
  likelyCause
  suggestedFix
  rulesReason
  assignedTo
  resolutionNotes
  resolvedAt
  reopenedCount
  fixHolding
`;

/**
 * The tickets, narrowed. `status: ""` lists every status (the API's own
 * default is "open"); severity, priority and service are optional filters.
 */
export const OPS_INCIDENTS = gql`
  query OpsIncidents(
    $status: String
    $severity: String
    $priority: String
    $service: String
    $limit: Int!
  ) {
    opsIncidents(status: $status, severity: $severity, priority: $priority, service: $service, limit: $limit) {
      ${OPS_INCIDENT_SUMMARY_FIELDS}
    }
  }
`;

/** One ticket, whole. */
export const OPS_INCIDENT = gql`
  query OpsIncident($id: Int!) {
    opsIncident(id: $id) {
      ${OPS_INCIDENT_DETAIL_FIELDS}
    }
  }
`;
